import { motion, Variants } from "framer-motion";
import HoverTag from "./HoverTag";
import style from "../login.module.scss";

type AnimateContentProps = {
  onLogin: () => void;
  isLoading: boolean;
};

const AnimateContent: React.FC<AnimateContentProps> = ({
  onLogin,
  isLoading,
}) => {
  const itemVariants: Variants = {
    hidden: { x: -300 },
    visible: {
      x: [-300, 10, -10, 0],
      transition: {
        duration: 0.6,
        ease: "easeOut",
        times: [0, 0.6, 0.85, 1],
      },
    },
  };

  return (
    <motion.div
      className={style.slideText}
      variants={itemVariants}
      initial="hidden"
      animate="visible"
    >
      <div className="inline-block relative mb-[7.35rem]">
        <p className="headline-l italic">
          Where work gets <br /> done with{" "}
          <span className="font-bold text-stroke-white">FUN</span>.
        </p>

        <HoverTag
          defaultText="The other (way better) F word"
          hoverText="Add a k to fun: upgrade!"
        />
      </div>

      <button
        onClick={onLogin}
        disabled={isLoading}
        className={`${style.loginButton} flex items-center rounded-full px-6 py-1 font-extrabold transition
        ${
          isLoading
            ? "cursor-not-allowed bg-gray-300 text-black"
            : "bg-white text-black hover:opacity-90"
        }`}
      >
        {isLoading ? "Please wait..." : "Log in with Company Account"}

        <span className="text-2xl font-normal">→</span>
      </button>
    </motion.div>
  );
};

export default AnimateContent;
